import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import VariavelService from 'business/cadastro/outros/variavel/variavelService'
import GrupoVariavelService from 'business/cadastro/outros/grupoVariavel/grupoVariavelService'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import GridForm from 'base/GridForm'
import ControllerInput from 'base/ControllerInput'
import { TabPanel, TabView } from 'primereact/tabview'
import OutputSpanForm from 'base/OutputSpanForm'
import { createCodeDescriptionObject, formatDatetime } from 'helper/formater'
import { errorToToast } from 'helper/error'

export default function Variavel() {

    const [service] = useState(() => new VariavelService())
    const [grupoVariaveis, setGrupoVariaveis] = useState([])
    const [validations, setValidations] = useState([])
    const toast = useRef(null)
    const stepperRef = useRef(null)
    const { id } = useParams()

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: 'onBlur'
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data?.grupo_variavel) {
            setGrupoVariaveis([createCodeDescriptionObject(data.grupo_variavel, 'codigo_gruv', 'descricao_gruv', false)])
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(schema => setValidations(schema))
    }, [service])

    const loadGrupoVariaveis = async () => {
        const list = new GrupoVariavelService()
        await list.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_gruv', 'descricao_gruv', false))
            setGrupoVariaveis(options)
        }).catch(err => errorToToast({ err, toast }))
    }

    return (
        <FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="descricao_var" form={form} service={service} type="text" clearString label="Descrição" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="nome_var" form={form} service={service} type="text" clearString label="Nome" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="valor_var" form={form} service={service} type="text" clearString label="Valor" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="cod_gruv_var" form={form} type="dropdown2" service={service} label="Grupo de variável"
                            optionKey='codigo_gruv'
                            optionLabel='descricao_gruv'
                            options={grupoVariaveis}
                            onLoad={loadGrupoVariaveis}
                        />
                    </GridForm>

                </TabPanel>

                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm>
                        <OutputSpanForm field="dh_ins_var" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_ins_var'))} label="Inserção" />
                        <OutputSpanForm field="dh_atua_var" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_atua_var'))} label="Atualização" />
                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
